// @ts-strict-ignore
import type { Schema } from '@empathyco/x-adapter'

import type { Filter, SearchRequest } from '@empathyco/x-types'

import type { PlaySearchRequest } from '../types'

import { isHierarchicalFilter } from '@empathyco/x-types'

import { EndpointContextEnum } from '../../../enums'

export const searchRequestSchema: Schema<SearchRequest, PlaySearchRequest> = {
  query: ({ query, extraParams: { context } }) => {
    if (context === EndpointContextEnum.QUERY) {
      return query
    }
  },
  browseField: ({ query, extraParams: { context } }) => {
    if (context === EndpointContextEnum.FILTER) {
      return query.split(':')[0]
    }
  },
  browseValue: ({ query, extraParams: { context } }) => {
    if (context === EndpointContextEnum.FILTER) {
      return query.split(':')[1]
    }
  },
  rows: 'rows',
  start: 'start',
  filter: ({ filters, extraParams: { raw } }): Array<string | number> | undefined => {
    if (raw?.filter?.length) {
      return raw.filter
    }
    // TODO: replace this map function by a schema object when this logic is moved from
    //  x-platform-adapter to x-components
    if (!filters || !Object.keys(filters).length) {
      return undefined
    }
    return Object.values(filters).reduce<Array<string | number>>((result, facetFilters) => {
      const facetFilterIsLastInHierarchy = (facetFilter: Filter): boolean =>
        !isHierarchicalFilter(facetFilter) ||
        !facetFilters.some(
          filter => isHierarchicalFilter(filter) && filter.parentId === facetFilter.id,
        )
      const getLastSelectedFacetFilterIdInHierarchy = (
        filterList: Array<string | number>,
        facetFilter: Filter,
      ): Array<string | number> =>
        facetFilterIsLastInHierarchy(facetFilter) ? [...filterList, facetFilter.id] : filterList

      return [
        ...result,
        ...facetFilters.reduce<Array<string | number>>(getLastSelectedFacetFilterIdInHierarchy, []),
      ]
    }, [])
  },
  debugEnabled: 'extraParams.debug',
  debugRankingDetails: 'extraParams.debug',
  mode: 'extraParams.mode',
}
